import * as React from 'react';
import Row from '@sdk/components/ui/spacing/Row';
import Href from '@sdk/components/ui/Href';
import Clickable from '@sdk/components/primitives/Clickable';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import RadioUncheckedSvg from '../../../assets/svg/Icons/18/radio-unchecked.svg';
import RadioCheckedSvg from '../../../assets/svg/Icons/18/radio-checked.svg';

type Props = {
  text: string;
  isChecked: boolean;
  isLast: boolean;
  onClick: () => void;
};

const ChecklistRow: React.FC<React.PropsWithChildren<Props>> = ({
  text,
  isChecked,
  isLast,
  onClick,
}) => (
  <Clickable onClick={onClick}>
    <Row alignItems="center" pBottom={!isLast && 18}>
      <Row pRight={10}>{isChecked ? <RadioCheckedSvg /> : <RadioUncheckedSvg />}</Row>
      <Href fontSize={14} themeColor={ThemeColorType.gray} semiBold hoverTextDecoration="none">
        {text}
      </Href>
    </Row>
  </Clickable>
);

export default ChecklistRow;
